import { useTranslation } from 'react-i18next'

import Icon from '../../../../../ui/Icon'

import { ClubModel } from '../../../../../../types/court/court'
import { formatAddress } from '../../../../../../utils/address/address'

type ClubSummaryProps = {
  club: ClubModel
}

const toHourMinute = (time: string) => time.slice(0, 5)

export const ClubSummary = ({ club }: ClubSummaryProps) => {
  const { t } = useTranslation('clubs')
  const formattedAddress = formatAddress(club.address, {
    number: t('address:number'),
    floor: t('address:floor'),
    apartment: t('address:apartment'),
  })

  if (club.id === undefined) {
    return null
  }

  const details = [
    {
      label: t('clubs.card.open-time'),
      value: toHourMinute(club.openTime),
    },
    {
      label: t('clubs.card.close-time'),
      value: toHourMinute(club.closeTime),
    },
    {
      label: t('clubs.card.free-cancellation'),
      value: t('clubs.card.hours', {
        count: club.freeCancellation,
      }),
    },
  ]

  return (
    <div className="club-summary">
      {formattedAddress && (
        <div className="club-address">
          <Icon name="pin" size={14} />
          <span>{formattedAddress}</span>
        </div>
      )}

      <div className="club-details">
        {details.map(detail => (
          <div className="club-detail" key={detail.label}>
            <span className="club-detail-label">{detail.label}</span>
            <span className="club-detail-value">{detail.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
